<template>
  <v-app>
    <v-content
      id="pages"
      :class="$vuetify.theme.dark ? undefined : 'grey lighten-3'"
    >
      <v-img
        :class="{
          'v-image--sm': this.$vuetify.breakpoint.smAndDown,
          'v-image--md': this.$vuetify.breakpoint.mdAndDown
        }"
        :src="require(`@/assets/login.jpg`)"
        gradient="to top, rgba(0, 0, 0, .5), rgba(0, 0, 0, .5)"
        min-height="100%"
      >
        <v-container
          class="error-page fill-height"
          tag="section"
        >
          <v-row
            class="text-center"
            justify="center"
          >
            <v-col cols="auto">
              <h1 class="title font-weight-black oidc-message">
                Oops..
              </h1>

              <div class="display-3 mb-5 mt-10 oidc-message">
                Error in authentication
              </div>

              <v-btn
                depressed
                to="/"
              >
                Get me out of here!
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-img>
    </v-content>
  </v-app>
</template>

<script>

  export default {
    name: 'OidcCallbackError',
  }
</script>

<style lang="sass">
  #pages
    > .v-content__wrap > .v-image
      padding-top: 64px
      padding-bottom: 88px

    .v-responsive__sizer
      display: none

    .v-image--md
      padding: 188px 0

    .v-image--sm
      padding: 96px 0 188px 0

    .error-page
      h1
        font-size: 12rem

    .oidc-message
        color: white
</style>
